function shoppingCartFake() {
  return (
    <div className="order-summary-fake" data-cy="shopping-cart-fake">
      <div className="shopping-cart-fake">
        <div className="shopping-cart-fake__details">
          <div className="shopping-cart-fake__details__product">
            <div className="skeleton skeleton-fake shopping-cart-fake__details__product__name-fake" />
            <div className="skeleton skeleton-fake shopping-cart-fake__details__product__price-fake" />
          </div>
          <div className="shopping-cart-fake__details__product">
            <div className="skeleton skeleton-fake shopping-cart-fake__details__product__name-fake" />
            <div className="skeleton skeleton-fake shopping-cart-fake__details__product__price-fake" />
          </div>
          <div className="shopping-cart-fake__details__product">
            <div className="skeleton skeleton-fake shopping-cart-fake__details__product__name-fake" />
            <div className="skeleton skeleton-fake shopping-cart-fake__details__product__price-fake" />
          </div>
        </div>
        <div className="skeleton skeleton-fake shopping-cart-fake__summary" />
      </div>
      <div className="skeleton skeleton-fake download-fake" />
      <div className="legal-terms-fake">
        <div className="skeleton skeleton-fake legal-terms-fake__check-fake" />
        <div className="skeleton skeleton-fake legal-terms-fake__link-fake" />
      </div>
      <div className="skeleton skeleton-fake button-fake" />
      <div className="skeleton skeleton-fake download-fake" />
      <style jsx>
        {`
          @import '../../styles/colors.scss';

          .skeleton-fake {
            border-radius: 4px;
          }
          .shopping-cart-fake {
            width: 100%;
            border-radius: 4px;
            border: 1px solid $color-gp--grey2;
          }
          .shopping-cart-fake__details {
            width: 100%;
            border-radius: 4px;
            background: white;
            display: flex;
            flex-direction: column;
            padding: 16px;
            .shopping-cart-fake__details__product {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              width: 100%;
              margin-bottom: 8px;
              .shopping-cart-fake__details__product__name-fake {
                width: 50%;
                height: 20px;
              }
              .shopping-cart-fake__details__product__price-fake {
                width: 20%;
                height: 20px;
              }
            }
          }
          .shopping-cart-fake__summary {
            width: 100%;
            height: 80px;
            border-radius: 0px;
            border-bottom-right-radius: 4px;
            border-bottom-left-radius: 4px;
          }
          .legal-terms-fake {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 100%;
            margin-top: 16px;
            margin-bottom: 16px;
            height: 22px;
            .legal-terms-fake__check-fake {
              width: 20px;
            }
            .legal-terms-fake__link-fake {
              width: 90%;
            }
          }
          .button-fake {
            width: 100%;
            height: 48px;
          }
          .download-fake {
            width: 100%;
            height: 20px;
            margin-top: 16px;
            margin-bottom: 8px;
          }
          @keyframes load {
            100% {
              background-position: -100% 0;
            }
          }
          @media screen and (min-width: 768px) {
            .shoppingCartFake {
            }
          }
        `}
      </style>
    </div>
  );
}
shoppingCartFake.propTypes = {};

shoppingCartFake.defaultProps = {};
export default shoppingCartFake;
